import type { MutableRefObject } from 'react';
import { useCallback, useEffect, useState } from 'react';
import type { EventWithTarget } from 'corgi-types';

/** Tracks mouse position within an DOM element */
export const useTrackMousePosition = () => {
  const [cursorPosition, setCursorPosition] = useState({ x: 50, y: 50 });

  const onMouseMove = useCallback(event => {
    const { clientX, clientY, currentTarget } = event;
    const { left, top, width, height } = currentTarget.getBoundingClientRect();

    const x = ((clientX - left) / width) * 100;
    const y = ((clientY - top) / height) * 100;
    setCursorPosition({ x, y });
  }, []);

  return { cursorPosition, onMouseMove };
};

export const useOnClickOutside = (
  handler: (event: EventWithTarget) => void,
  ref: MutableRefObject<HTMLElement>
) => {
  useEffect(() => {
    const listener = (event: EventWithTarget) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};
